/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FullBotUi,
} from '../models';

export interface ReimportVehiclesByPublicBotIdRequest {
    publicId: string;
}

/**
 * 
 */
export class VehicleReimportControllerApi extends runtime.BaseAPI {

    /**
     */
    async reimportVehiclesByPublicBotIdRaw(requestParameters: ReimportVehiclesByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullBotUi>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling reimportVehiclesByPublicBotId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/reimport/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async reimportVehiclesByPublicBotId(requestParameters: ReimportVehiclesByPublicBotIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullBotUi> {
        const response = await this.reimportVehiclesByPublicBotIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
